<template>
  <el-form
    @submit.native.prevent="save"
    ref="form"
    label-position="top"
    id="contenido"
    enctype="multipart/form-data"
  >
    <el-row type="flex" justify="space-between">
      <el-col :span="6">
        <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
          <el-input v-model="template.title"></el-input>
          <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6">
        <el-form-item label="Posición de la imagen">
          <select class="select" v-model="template.position">
            <option value="1">Izquierda</option>
            <option value="2">Derecha</option>
            <option value="3">Ancho total</option>
          </select>
        </el-form-item>
      </el-col>
      <el-col :span="1"></el-col>
      <el-col :span="6">
        <el-form-item label="Toggle">
          <el-radio-group v-model="template.toggle">
            <el-radio-button :label="1">Abierto</el-radio-button>
            <el-radio-button :label="2">Cerrado</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <app-cropper :options="options"></app-cropper>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-form-item label="Texto" v-if="showEditor">
          <app-vue-editor :value="template.text"></app-vue-editor>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Editor from "@/components/_commons/vue-editor";

export default {
  name: "contenido",
  props: ["content", "status"],
  components: {
    "app-vue-editor": Editor,
    "app-cropper": Cropper
  },
  created() {
    this.content ? this.getContent() : (this.showEditor = true);
    this.$root.$on("imagenCargada", file => {
      this.template.image = file;
    });
    this.$root.$on("imagenEliminada", () => (this.template.image = "NULL"));

    this.$root.$on("saveContent", id => {
      this.id = id;
      this.section_id = id;
      this.setSave();
    });
    this.$root.$on("vue-editor", e => {
      this.template.text = e;
    });
  },
  watch: {
    $route(to) {
      if (this.content) this.getContent();
    }
  },
  data() {
    return {
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 450,
        autoCropWidth: 820,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [820, 450]
      },
      table: "contenido",
      uploadsUrl: API_UPLOADS,
      template: {
        title: "",
        text: "",
        image: false,
        position: 3,
        date: "",
        toggle: 1
      },
      noImage: true,
      errorTitle: false,
      formData: false,
      id: false,
      count: 0,
      showEditor: false
    };
  },
  methods: {
    async getContent() {
      const a = await ApiService.post("dashboard/table", {
        table: "contenido",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.content_id
      });
      if (a.status === 200) {
        this.template = a.data;
        if (
          a.data.image != 0 &&
          a.data.image != "0" &&
          a.data.image != "NULL"
        ) {
          this.template.image = {
            url: this.uploadsUrl + a.data.image
          };
          this.options.img = this.template.image.url;
          this.noImage = false;
        }
        this.showEditor = true;
      }
    },
    save() {
      // método creado para solventar error de crooper al terminar edición
    },
    async setSave() {
      if (this.template.image) {
        if (this.template.image.size) {
          let data = new FormData();
          data.append("file", this.template.image);
          const a = await ApiService.post("upload/contenido", data);
          this.template.image = a.data;
        } else if (this.template.image.url) {
          let e = this.template.image.url.replace(this.uploadsUrl, "");
          let a = e.replace(this.uploadsUrl + this.uploadsUrl, "");
          let b = a.replace(
            this.uploadsUrl + this.uploadsUrl + this.uploadsUrl,
            ""
          );
          this.template.image = b;
        }
      } else {
        this.template.image = "NULL";
      }

      this.content != 0 ? this.update() : this.insert();
    },
    async update() {
      await ApiService.post("dashboard/editform", {
        table: "contenido",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template,
        id: this.$route.params.content_id
      });
      //alert(this.template.image)
    },
    async insert() {
      this.count = this.count + 1;
      const a = await ApiService.post("dashboard/editform", {
        table: "contenido",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.template
      });
      if (a.status === 200) {
        const b = await ApiService.post("dashboard/editform", {
          table: "contents",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: {
            template_id: 1,
            registro_id: a.data
          }
        });
        if (b.status === 200) {
          await ApiService.post("dashboard/editform", {
            table: "sections_contents",
            token: localStorage.getItem("token"),
            project_id: localStorage.getItem("table"),
            form: {
              section_id: this.section_id,
              content_id: b.data
            }
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/templates/contenido.vue